// SamostoyatelnayaRegistratsiyaKollektivaFederatsii
import React from 'react';
import { useSelector } from 'react-redux';
import { Form, Input, Select } from 'antd';



import { getShkolaFromRoles } from '../../../common/Tool';

const { Option } = Select;


export default function SamostoyatelnayaRegistratsiyaKollektivaFederatsii(props) {
    const shkola = useSelector(getShkolaFromRoles(["ВладелецШколыФедерации", "АдминистраторШколыФедерации"]));

    const options = shkola.filter(i=>{
        if (!i.dokumentRegistratsiiID ||
            (i.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                i.zayavlenieOtVladeltsaShkoliNaVikhodID)) {
            if (!i.dokumentRegistratsiiID && i.dokumentPodachiZayavleniyaNaRegistratsiyuID) {
                return false;
            }
            if ((i.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID ||
                i.zayavlenieOtVladeltsaShkoliNaVikhodID) && !i.dokumentVikhodaIzFederatsiiID) {
                return false;
            }
        }
        return true;
    }).map(i => (
        <Option key={i.ID} value={i.ID}>{i.nazvanieShkoliTantsev}</Option>
    ));

    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                // neobkhodimiiKvorum: 50,
            }}
        >
            <Form.Item
                name={"nazvanieKollektiva"}
                label={"Название коллектива"}
                rules={[{ required: true, message: 'Укажите название коллектива!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"shkolaFederatsiiID"}
                label={"Школа федерации"}
                rules={[{ required: true, message: 'Укажите школу федерации!' }]}
            >
                <Select showSearch autoComplete="off"
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {options}
                </Select>
            </Form.Item>
        </Form>
    );
}
